export default "__VITE_ASSET__DCoaC7Gp__"